import { doc, getDoc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "./siteData";

/* -------------------------------------------------------------------------- */
/*  ABOUT US PAGE CONTENT  (Firestore document: site/about)                   */
/*  The public About page will read this same document, so Publish = live.    */
/*  Each step's `icon` is a key: pin, search, clipboard, truck, wrench,       */
/*  handshake.                                                                */
/* -------------------------------------------------------------------------- */

// What the About page shows today, so the manager opens pre-filled the first time.
export const DEFAULT_ABOUT = {
  intro: {
    title: "Water and solar power, wherever in Kenya you are.",
    text: "MajiMaji Water Solutions drills boreholes and installs solar systems for homes, farms and businesses across the country. One team, one way of working, in every county.",
  },
  how: {
    title: "How we serve the whole country",
    text: "Our crews travel to you, and the process is the same whether your land is near the office or far from it.",
    image:
      "https://res.cloudinary.com/dj6wdsbtx/image/upload/v1791732731/Golden-Hour_Drilling_in_the_Valley_mcazyh.png",
    imageAlt: "Drilling rig working in a valley at golden hour",
    steps: [
      {
        icon: "pin",
        title: "You tell us where",
        text: "Call or send a message from any county. We note the location, what you need, and how you plan to use the water or power.",
      },
      {
        icon: "search",
        title: "We survey the site",
        text: "A team visits your land to assess it and recommend where to drill or how to size your solar system, before you commit to anything.",
      },
      {
        icon: "clipboard",
        title: "You get a clear quote",
        text: "An itemised quote that covers the work, the materials and the travel to your site. No surprises later.",
      },
      {
        icon: "truck",
        title: "Our crew comes to you",
        text: "Our drilling and installation crews travel with their equipment, so the work is done on your site to the same standard wherever you are.",
      },
      {
        icon: "wrench",
        title: "We stay on call",
        text: "After handover we show you how everything works and remain available for servicing, repairs and questions.",
      },
    ],
  },
  ceo: {
    name: "Mannase Maina",
    role: "Chief Executive Officer",
    // Empty means the public page shows a monogram instead of a photo.
    photo: "",
    bio: [
      "Mannae leads MajiMaji Water Solutions, setting the standards for how every borehole is sited, drilled and handed over, and how every solar system is designed and installed.",
      "He believes dependable water and clean power should be within reach of every home, farm and business in Kenya, and that clients deserve clear quotes and honest advice from the first call.",
    ],
  },
  cta: {
    title: "Ready to talk about your project?",
    text: "Tell us where you are and what you need, and we will arrange a site visit and a free quote.",
  },
};

const aboutRef = () => doc(db, "site", "about");

export async function loadAbout() {
  const snap = await getDoc(aboutRef());
  if (!snap.exists()) return { data: DEFAULT_ABOUT, exists: false, updatedAt: null };
  const { updatedAt, updatedBy, ...data } = snap.data();
  // Merge section by section so an older document never leaves a field undefined.
  return {
    data: {
      intro: { ...DEFAULT_ABOUT.intro, ...data.intro },
      how: { ...DEFAULT_ABOUT.how, ...data.how },
      ceo: { ...DEFAULT_ABOUT.ceo, ...data.ceo },
      cta: { ...DEFAULT_ABOUT.cta, ...data.cta },
    },
    exists: true,
    updatedAt: updatedAt?.toDate?.() ?? null,
  };
}

export async function saveAbout(data, by) {
  await setDoc(aboutRef(), {
    intro: data.intro,
    how: data.how,
    ceo: data.ceo,
    cta: data.cta,
    updatedAt: serverTimestamp(),
    updatedBy: by || "",
  });
}